module.exports = ".group-actions{\n    width: 200px !important;\n    min-width: 200px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-group/company-group.component.css
// module id = ./src/app/views/companies/company-group/company-group.component.css
// module chunks = main